import React, { Fragment } from "react";
import dataPanel from "../../../service/dataPanel.json";
import BunnerCardProduct from "../../../utility/templete/bunnerCardProduct";
import CheckUnckeck from "../../../utility/templete/checkUnckeck";
import { toNumeric } from "../../../utility/stringExtensions";
const BunnerUsersSmall = () => {
  return (
    <div className="container">
      <div className="row">
        {dataPanel.panelUser.map((p) => (
          <BunnerCardProduct
            title={p.title}
            color={p.color}
            price={
              toNumeric(p.price)
              // <NumberFormat
              //   value={p.price}
              //   displayType={"text"}
              //   thousandSeparator={true}
              //   prefix={"تومان"}
              // />
            }
            info={
              <Fragment>
                <CheckUnckeck
                  value={1}
                  title={`${p.percentUseSystenm}% امکانات سامانه`}
                />
                <CheckUnckeck value={1} title={p.freeDedicatedLineTitle} />
                <CheckUnckeck
                  value={p.serviceLine_WithoutTheNeedForDocuments}
                  title={p.serviceLine_WithoutTheNeedForDocumentsTitle}
                />
                <CheckUnckeck
                  value={p.sendASIMCard}
                  title={p.sendASIMCardTitle}
                />
                <CheckUnckeck
                  value={p.sendVoiceMessage}
                  title={p.sendVoiceMessageTitle}
                />
                <CheckUnckeck
                  value={p.provideWebServiceAPI}
                  title={p.provideWebServiceAPITitle}
                />
                <CheckUnckeck
                  value={p.cloudLandline}
                  title={p.cloudLandlineTitle}
                />
                <CheckUnckeck
                  value={p.sMSSecretary}
                  title={p.sMSSecretaryTitle}
                />
                <CheckUnckeck
                  value={p.smartResponder}
                  title={p.smartResponderTitle}
                />
                <CheckUnckeck
                  value={p.contestAndSMSPoll}
                  title={p.contestAndSMSPollTitle}
                />
                <CheckUnckeck value={p.codeReader} title={p.codeReaderTitle} />
                <CheckUnckeck value={p.sMSQueuing} title={p.sMSQueuingTitle} />
                <CheckUnckeck
                  value={p.patternWebService}
                  title={p.patternWebServiceTitle}
                />
                <CheckUnckeck
                  value={p.instantSendingOTPSMS}
                  title={p.instantSendingOTPSMSTitle}
                />
                <CheckUnckeck
                  value={p.sendCustomerClub}
                  title={p.sendCustomerClubTitle}
                />
                <CheckUnckeck value={1} title={"10روز ضمانت عودت"} />
                {/* <CheckUnckeck
                  value={0}
                  title={`تعرفه هر پیامک ${p.tariffForEachSMS} تومان`}
                /> */}
              </Fragment>
            }
            link="/FacilitiesAndTariffs"
            btnTitleLink="اطلاعات بیشتر"
          />
        ))}
      </div>
    </div>
  );
};

export default BunnerUsersSmall;
